export const COMUNICACION_CONTENT = {
    lessons: {
        // comunicacion.campanas — «Campañas a socios» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "crm.campanas" — práctica: sí
        "comunicacion.campanas": {
            summary: "Aprendés a armar una campaña de retención: elegir a quién le escribís (ausentes de catorce días o más, cuota vencida, plan por vencer, cumpleaños del mes, ex socios o interesados perdidos), qué le decís, por qué canal y cuándo sale. Ves cómo se lee el conteo en vivo antes de mandarla, cuándo todavía se puede cancelar y cómo el sistema mide solo quién la leyó, renovó o volvió.",
            keyPoints: [
                "Una campaña es: nombre + segmento y sede + aviso + canales (push, email y centro de avisos de la app) + día y hora de envío. Crearla y enviarla queda registrado con tu nombre.",
                "El conteo de cada segmento es en vivo: es a cuántos les llegaría hoy. Al enviar, la campaña deja fijo ese número para poder comparar el resultado después.",
                "Una campaña programada sale sola a la hora fijada (hora de Buenos Aires) y hasta entonces se puede cancelar; con Enviar sale en el momento. Una campaña enviada no se cancela: lo que la gente recibió, recibió.",
                "Nadie recibe dos avisos del mismo tipo el mismo día. Si algunos quedan afuera por eso, el sistema lo dice: no es un error, es para no saturar a nadie.",
                "El centro de avisos guarda el aviso siempre, aunque el socio no tenga app ni mail: avisale en recepción la próxima vez que venga. Si los segmentos no se pueden contar, el sistema avisa que falló la consulta en vez de mostrar un cero.",
                "El resultado se completa solo en los días siguientes: entregados, leídos, cuántos renovaron y cuántos volvieron a entrenar.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // comunicacion.noticias — «Noticias y moderación del muro» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "crm.moderacion" — práctica: no
        "comunicacion.noticias": {
            summary: "Aprendés a moderar el muro social de los socios y a publicar noticias en la app (para todo el club o para una sede, destacadas o programadas). Ves cómo funciona la cola de moderación, por qué sacar contenido de un socio exige motivo, qué hace una suspensión y qué pasa con lo que se elimina.",
            keyPoints: [
                "Por revisar junta todo lo que espera a alguien: publicaciones pendientes, lo que ocultó una denuncia y los comentarios denunciados. Si la moderación previa está prendida, lo que publica un socio no se ve hasta que alguien lo aprueba.",
                "Rechazar: no se publica. Ocultar: deja de verse pero queda guardado y se puede restituir. Eliminar: se conserva noventa días por si hay que revisarlo y después se borra. Las tres piden motivo y quedan en la auditoría con tu nombre.",
                "Un comentario denunciado se oculta solo y llega a la cola: si la denuncia no tenía sentido se restituye; si la tenía, se oculta o se elimina con motivo.",
                "Suspender a un publicador pide días y motivo: sólo deja de poder publicar, sigue entrenando y entrando al club. Se levanta sola al vencer o antes con Levantar suspensión.",
                "Una noticia lleva título, texto y fotos; el alcance es todo el club o una sede, con fecha futura queda programada y destacada aparece arriba de todo. Despublicada se puede volver a publicar.",
                "«No se pudo leer la cola» no es una cola vacía: falló la consulta. «Nada para mostrar» sí es un resultado real.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
    },
    questions: [
        // ── comunicacion.campanas ───────────────────────────────────────────────
        {
            id: "comunicacion.campanas#1",
            lessonKey: "comunicacion.campanas",
            prompt: "Programaste una campaña para el viernes y el jueves te das cuenta de que el mensaje tiene un error. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "La dejás salir y el viernes mandás otra campaña a los mismos socios con la corrección.",
                },
                {
                    id: "b",
                    text: "La cancelás, porque todavía no salió, y armás una nueva bien escrita.",
                },
                {
                    id: "c",
                    text: "Esperás a que salga y la cancelás después: así a los socios se les borra el aviso.",
                },
                { id: "d", text: "No se puede hacer nada: una campaña programada ya no se toca." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, una campaña programada sale sola a la hora fijada y hasta entonces la podés cancelar. Una vez enviada ya no se cancela: lo que la gente recibió, recibió.",
        },
        {
            id: "comunicacion.campanas#2",
            lessonKey: "comunicacion.campanas",
            prompt: "Querés mandar una campaña a ausentes, pero en lugar del número del segmento el sistema dice que falló la consulta. ¿Qué conviene hacer?",
            options: [
                {
                    id: "a",
                    text: "Esperar a que el conteo vuelva antes de mandarla, para no mandar a ciegas.",
                },
                {
                    id: "b",
                    text: "Mandarla igual: si no muestra número es porque hay cero ausentes y no le llega a nadie.",
                },
                {
                    id: "c",
                    text: "Mandarla a Todo el club en lugar del segmento, así seguro les llega a los ausentes.",
                },
                {
                    id: "d",
                    text: "Cargar a mano la cantidad de ausentes que calculás, para que la campaña quede medida.",
                },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si los segmentos no se pueden contar el sistema no te muestra un cero: te avisa que falló la consulta, y conviene esperar antes de mandar. Sin número, no se manda a ciegas.",
        },
        {
            id: "comunicacion.campanas#3",
            lessonKey: "comunicacion.campanas",
            prompt: "Un socio del segmento «cuota vencida» no tiene la app instalada ni dejó mail. ¿Qué pasa con él cuando sale la campaña?",
            options: [
                {
                    id: "a",
                    text: "El sistema lo saca del segmento para no inflar el conteo de destinatarios.",
                },
                {
                    id: "b",
                    text: "La campaña queda frenada hasta que todos los socios del segmento tengan algún canal.",
                },
                {
                    id: "c",
                    text: "El aviso queda en su centro de avisos; conviene avisarle en recepción cuando venga.",
                },
                {
                    id: "d",
                    text: "No le llega nada ni queda registrado: para él la campaña no existió.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el centro de avisos guarda el aviso siempre, aunque el socio no tenga la app ni mail. Por eso conviene avisarle en recepción la próxima vez que venga.",
        },
        {
            id: "comunicacion.campanas#4",
            lessonKey: "comunicacion.campanas",
            prompt: "Al enviar una campaña, el sistema te avisa que algunos socios quedaron afuera porque ese día ya recibieron un aviso del mismo tipo. ¿Cómo lo tomás?",
            options: [
                {
                    id: "a",
                    text: "Es un error: reenviás la campaña a mano hasta que les llegue a todos.",
                },
                {
                    id: "b",
                    text: "Es una falla del segmento: la cancelás y armás otra con los que quedaron afuera.",
                },
                {
                    id: "c",
                    text: "Es porque esos socios bloquearon los avisos del club desde la app.",
                },
                {
                    id: "d",
                    text: "No es un error: nadie recibe dos avisos del mismo tipo el mismo día.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, nadie recibe dos avisos del mismo tipo el mismo día. Si algunos quedan afuera por eso, el sistema te lo dice: no es un error, es para no saturar a nadie.",
        },
        // ── comunicacion.noticias ───────────────────────────────────────────────
        {
            id: "comunicacion.noticias#1",
            lessonKey: "comunicacion.noticias",
            prompt: "Un socio denuncia un comentario del muro. Lo revisás en la cola y la denuncia no tenía sentido: el comentario estaba bien. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Nada: el comentario nunca se ocultó, porque una denuncia sola no lo saca del muro.",
                },
                {
                    id: "b",
                    text: "Lo restituís: se había ocultado solo al denunciarlo y vuelve a verse.",
                },
                {
                    id: "c",
                    text: "Lo eliminás igual, porque una vez denunciado ya no puede volver al muro.",
                },
                {
                    id: "d",
                    text: "Suspendés a quien lo denunció, para que no vuelva a denunciar sin motivo.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, cuando un socio denuncia un comentario, el comentario se oculta solo y llega a la cola. Si la denuncia no tenía sentido, lo restituís; si la tenía, lo ocultás o lo eliminás, con motivo.",
        },
        {
            id: "comunicacion.noticias#2",
            lessonKey: "comunicacion.noticias",
            prompt: "Una sede cierra el sábado por una obra y querés avisarlo en Noticias sólo a los socios de esa sede, bien visible. ¿Cómo cargás la noticia?",
            options: [
                {
                    id: "a",
                    text: "Con alcance en esa sede y marcada como Destacada.",
                },
                {
                    id: "b",
                    text: "Para todo el club, aclarando la sede en el título para que se entienda a quién va.",
                },
                { id: "c", text: "Como publicación en el muro social, para que los socios la comenten." },
                { id: "d", text: "Con fecha del sábado, así aparece recién el día del cierre." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, en Alcance elegís todo el club o una sola sede, y si la marcás Destacada aparece arriba de todo. Ponerle fecha futura la dejaría programada, y el aviso llegaría tarde.",
        },
        {
            id: "comunicacion.noticias#3",
            lessonKey: "comunicacion.noticias",
            prompt: "Un socio insiste en publicar cosas que no van y lo suspendés como publicador por 15 días. ¿Qué pasa con él en ese tiempo?",
            options: [
                {
                    id: "a",
                    text: "No puede entrar al club hasta que se levante la suspensión.",
                },
                {
                    id: "b",
                    text: "Se le borran todas sus publicaciones anteriores del muro.",
                },
                {
                    id: "c",
                    text: "Queda suspendido hasta que alguien la levante a mano, aunque pasen los 15 días.",
                },
                {
                    id: "d",
                    text: "Sigue entrenando normal; sólo no puede publicar, y se levanta sola al vencer.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, suspender corta sólo la posibilidad de publicar: la persona sigue entrenando y entrando al club. La suspensión se levanta sola al vencer, o antes con Levantar suspensión.",
        },
        {
            id: "comunicacion.noticias#4",
            lessonKey: "comunicacion.noticias",
            prompt: "Querés sacar del muro la foto de un socio mientras lo consultás con la dueña, porque quizás vuelva a publicarse. ¿Qué opción usás?",
            options: [
                {
                    id: "a",
                    text: "Eliminar, porque se guarda noventa días y en ese plazo se puede volver a mostrar igual.",
                },
                {
                    id: "b",
                    text: "Rechazar, que la saca del muro sin pedir motivo hasta que decidas.",
                },
                {
                    id: "c",
                    text: "Ocultar, con motivo: deja de verse, queda guardada y se puede restituir.",
                },
                {
                    id: "d",
                    text: "Ninguna: lo publicado en el muro no se puede sacar una vez aprobado.",
                },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, Ocultar hace que deje de verse pero queda guardada y se puede restituir. Eliminar la conserva noventa días sólo para revisarla y después se borra. Las tres opciones piden motivo.",
        },
    ],
};
//# sourceMappingURL=comunicacion.js.map